<template>
  <div class="pay">
    <van-nav-bar
      title="静音时间段"
      left-text="返回"
      left-arrow
      @click-left="$router.go('-1')"
    />
    <van-notice-bar :scrollable="false" text="静音时间段您将无法拨打孩子电话" />
    <c-card
      class="pay-row c-margin-top-normal"
      v-for="(item, index) in list"
      :key="index"
    >
      <p class="pay-row-item">
        <label class="pay-row-item__title">状态：</label>
        <label v-if="(item.Ison===1)">开启</label>
        <label v-else>关闭</label>
      </p>
      <p class="pay-row-item">
        <label class="pay-row-item__title">星期：</label>
        {{getWeekname(item.Week)}} 
      </p>
      <p class="pay-row-item">
        <label class="pay-row-item__title">时间：</label>
        {{item.St}} 至 {{item.Et}}
      </p>
    </c-card>
  </div>
</template>

<script>
import { NavBar, NoticeBar, Toast, Switch } from 'vant'
import CCard from '@/components/c-card.vue'

export default {
  data() {
    return {
      studnetInfo:{},
      list: []
    }
  },
  created() {
    
  },
  mounted() {
    this.getDeviceMuteInfo()
  },
  methods: {
    // 获取学生信息
    getDeviceMuteInfo() {
      var sinfo = localStorage.getItem("currentChild");
        this.studnetInfo = JSON.parse(sinfo);
      this.$http
        .json_post(this.$api.studentcard.getmuteinfo, {
          Deviceid:  this.studnetInfo.Deviceid
        })
        .then(data => {
          if (data.code == 0) {
            this.list = data.data
          }else{
            Toast(data.msg)
          }
        })
    },
    getWeekname (weekvalue) {
      var weekArr = [
        '周一',
        '周二',
        '周三',
        '周四',
        '周五',
        '周六',
        '周日'
      ]
      var sweekname = ''
      if (weekvalue ==='') return '无'
      for(var i=0;i < weekvalue.length; i++) {
        if (weekvalue.substring(i,i+1) ==="1") {
          sweekname += weekArr[i] + ","
        }
      }
      return  sweekname
    },
    stringToArr(str) {
      var weekArr = [
        '',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
        '星期日'
      ]
      var retArr = new Array()
      var strings = str.split(';')
      for (var i = 0; i < strings.length; i++) {
        var model = {}
        var strs1 = strings[i].split('|')
        var strs2 = strs1[0].split(',')
        var strs3 = strs1[1].split(',')
        model.beiginName = weekArr[parseInt(strs2[0])]
        model.endName = weekArr[parseInt(strs2[1])]
        model.begin = strs3[0]
        model.end = strs3[1]
        retArr[i] = model
      }
      return retArr
    }
  },
  components: {
    'van-nav-bar': NavBar,
    'van-notice-bar': NoticeBar,
    'van-switch': Switch,
    'c-card': CCard
  }
}
</script>

<style lang="scss" scoped>
.pay-row-item {
  line-height: 20px;
  .pay-row-item__title {
    display: inline-block;
    width: 70px;
    color: $text-secondary-color;
  }
}
</style>
